/* LittleG everyday tools launcher/search.
 * Each calculator owns its own deterministic JS, CSS and snippet.
 * This navigation owner never uploads dimensions, charges GFun or grants access.
 */
(function(global){
  'use strict';
  if(!global.document)return;
  global.document.querySelectorAll('[data-littleg-life-tools]').forEach(root=>{
    const controls=[...root.querySelectorAll('[data-life-open]')];
    const panel=root.querySelector('[data-life-panel]');
    if(!panel)return;
    const forms=[...panel.querySelectorAll('[data-life-calc]')];

    function open(kind){
      const active=controls.find(button=>button.dataset.lifeOpen===kind);
      const chosen=forms.find(form=>form.dataset.lifeCalc===kind);
      if(!active||!chosen)return;
      panel.hidden=false;
      controls.forEach(button=>button.setAttribute('aria-expanded',String(button===active)));
      forms.forEach(form=>{form.hidden=form!==chosen;});
      const title=panel.querySelector('[data-life-panel-title]');
      if(title)title.textContent=active.dataset.lifeTitle||active.textContent.trim();
      if(typeof panel.scrollIntoView==='function'){
        const reduceMotion=typeof global.matchMedia==='function'&&global.matchMedia('(prefers-reduced-motion: reduce)').matches;
        panel.scrollIntoView({block:'start',behavior:reduceMotion?'auto':'smooth'});
      }
      const first=chosen.querySelector('input');
      if(first&&typeof first.focus==='function')first.focus({preventScroll:true});
    }

    controls.forEach(button=>button.addEventListener('click',()=>open(button.dataset.lifeOpen)));

    // Deep links from the 12 city Hotspots. Open only the five actual
    // local calculators; 'area' belongs to the existing GProperty Map.
    // Do not read arbitrary selectors, customer state or execute on user input.
    const requested = (() => {
      if (!global.location || typeof URLSearchParams === 'undefined') return null;
      const value = new URLSearchParams(global.location.search || '').get('littleg_tool');
      return ['fit','tiles','paint','room','route'].includes(value) ? value : null;
    })();
    if (requested && controls.some(button => button.dataset.lifeOpen === requested) &&
        forms.some(form => form.dataset.lifeCalc === requested)) {
      // Render / layout before measuring the target scroll position.
      const run = () => open(requested);
      if (typeof global.requestAnimationFrame === 'function') global.requestAnimationFrame(run);
      else run();
    }
    const search=root.querySelector('[data-life-search]');
    const items=[...root.querySelectorAll('[data-life-tile]')];
    const empty=root.querySelector('[data-life-search-empty]');
    if(search)search.addEventListener('input',()=>{
      const query=search.value.trim().toLocaleLowerCase();
      let visible=0;
      for(const item of items){
        const label=((item.dataset.lifeKeywords||'')+' '+item.textContent).toLocaleLowerCase();
        item.hidden=query!==''&&!label.includes(query);
        if(!item.hidden)visible++;
      }
      if(empty)empty.hidden=visible>0;
    });
  });
})(typeof window==='undefined'?globalThis:window);
